<template>
  <AlertDialog>
    <TooltipProvider>
      <Tooltip :delay-duration="350">
        <TooltipTrigger as-child>
          <AlertDialogTrigger>
            <Icon name="mdi-trash-can" color="gray-200" />
          </AlertDialogTrigger>
        </TooltipTrigger>
        <TooltipContent class="bg-primary text-sm">
          <p>Inclusion manuelle dans le programme: </p>
          <div v-for="inclusion in program.inclusions" :key="inclusion.id">
            <strong>{{ groupLabel(inclusion) }} le {{ dateHelper.shortFormat(inclusion.created_at) }}</strong>
            <span v-if="inclusion.comments">
              <br> <Icon name="mdi-message" color="white" :size="12" /> {{ inclusion.comments }}
            </span>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
    <AlertDialogContent @close-auto-focus="(e) =>e.preventDefault()">
      <AlertDialogHeader>
        <AlertDialogTitle>Retirer {{ consumer.information.first_name }} du programme ?</AlertDialogTitle>
        <AlertDialogDescription>
          Cette action retirera le patient du programme <strong>{{ program.name }}</strong>.
          Vous pourrez l'ajouter à nouveau si nécessaire.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel as-child class="!shadow-none">
          <BaseButton>Annuler</BaseButton>
        </AlertDialogCancel>
        <AlertDialogAction as-child>
          <BaseButton primary @click="deleteInclusion">
            Confirmer
          </BaseButton>
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
</template>

<script lang="ts" setup>
import Icon from "@/core/components/icon/Icon.vue";
import {customerProgramApi} from "@/container";
import {
    AlertDialog,
    AlertDialogTrigger,
    AlertDialogContent,
    AlertDialogHeader,
    AlertDialogFooter,
    AlertDialogTitle,
    AlertDialogDescription,
    AlertDialogAction,
    AlertDialogCancel
} from "@/core/components/ui/alert-dialog";
import Customer from "@/customer/interfaces/Customer";
import Beneficiary from "@/customer/interfaces/Beneficiary";
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Tooltip, TooltipProvider, TooltipContent, TooltipTrigger} from "@/core/components/ui/tooltip";
import dateHelper from "@/core/helpers/dateHelper";
import {ProgramInclusion, ProgramSnapshot} from "@/program/interfaces/Program";

const props = defineProps<{
    program: ProgramSnapshot;
    consumer: Customer | Beneficiary;
}>();

const emit = defineEmits(['trash-program']);

/**
 * Get the group label of the program inclusion.
 * @param inclusion
 */
const groupLabel = (inclusion: ProgramInclusion) => {
    if (!inclusion.group || !props.program.meta) {
        return 'Inclusion libre';
    }

    if (Object.keys(props.program.meta.included).includes(inclusion.group)) {
        return props.program.meta.included[inclusion.group];
    }

    if (Object.keys(props.program.meta.excluded).includes(inclusion.group)) {
        return props.program.meta.excluded[inclusion.group];
    }

    return "Ciblage inconnu";
};

/**
 * Delete the program inclusion (in API).
 */
const deleteInclusion = async () => {
    emit('trash-program', props.program.id);

    const promises = props.program.inclusions?.map((inclusion: ProgramInclusion) => {
        return customerProgramApi().deleteInclusion(props.program.id, inclusion.id);
    });

    if (promises) {
        await Promise.all(promises);
    }
};
</script>
